import { render, staticRenderFns } from "./AccountCards.vue?vue&type=template&id=5f292770&v-profile-guard='components.dataAccount.read'"
import script from "./AccountCards.vue?vue&type=script&lang=js"
export * from "./AccountCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f292770')) {
      api.createRecord('5f292770', component.options)
    } else {
      api.reload('5f292770', component.options)
    }
    module.hot.accept("./AccountCards.vue?vue&type=template&id=5f292770&v-profile-guard='components.dataAccount.read'", function () {
      api.rerender('5f292770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountCards.vue"
export default component.exports